module.exports = __webpack_public_path__ + "static/icons/icon-caret-down-solid-48b20ee1158b1039123ebf74d94daf81.svg";